import React from 'react';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PropTypes from 'prop-types';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {openFile} from 'Shared/utilities/fetchHelpers';
import {BulletinDto} from 'Documents/api';
import {Button} from '@material-ui/core';
import {createSnackbar} from 'Core/ducks/snackbar';
import {useDispatch} from 'react-redux';
import {Conflict, NotFound, ServerError, Unauthorized} from 'Core/models/Async';

type BulletinsDocumentProps = {
    bulletin: BulletinDto;
    selectedAgency: AgencyFilters;
};


const BulletinsDocument = (props: BulletinsDocumentProps) => {
    const {bulletin} = props;
    const bulletinUrl = `/api/documents/v1/bulletins/${bulletin.bulletinId}`;
    const fileExtension = `pdf`;
    const successResponse = `Sucessfully Downloaded!`;

    const dispatch = useDispatch();
    const getBulletinsDoc = (bulletin: BulletinDto) => {
        dispatch(createSnackbar("Request initiated!"))
        const response = openFile(bulletinUrl, fileExtension, successResponse);
        response.then(value => {
            const pdfResponse: any = value;
            if (typeof pdfResponse === 'string') {
                dispatch(createSnackbar(successResponse));
            } else if (pdfResponse instanceof NotFound) {
                dispatch(createSnackbar(pdfResponse.message));
            } else if (pdfResponse instanceof Unauthorized) {
                dispatch(createSnackbar(pdfResponse.message));
            } else if (pdfResponse instanceof Conflict) {
                dispatch(createSnackbar(pdfResponse.message));
            } else if (pdfResponse instanceof ServerError) {
                dispatch(createSnackbar(pdfResponse.message));
            } else {
                dispatch(createSnackbar("Unable to download form!"));
            }
        });
    }

    return (
        <>
            {/* <Link to={bulletinUrl} target="_blank" > */}
            <Button
                id={`bulletins-view-details-btn-${bulletin.bulletinId}`}
                className="primary-action-button"
                color="primary"
                onClick={(bulletin: BulletinDto) => getBulletinsDoc(bulletin)}
            >
                <DescriptionOutlinedIcon color="error"/>
            </Button>
            {/* </Link> */}
        </>
    )
}
BulletinsDocument.propTypes = {
    documents: PropTypes.arrayOf(PropTypes.object),
    date: PropTypes.string,
    uniquePolicyNumber: PropTypes.string
};
BulletinsDocument.defaultProps = {
    documents: [],
    date: null,
    uniquePolicyNumber: null
};
export default BulletinsDocument;
